import template from "./signin.html";
import {SigninController} from "./signin.controller";

const controllerAs = "signin";

const SigninComponent = {
	template,
	controller: SigninController,
	controllerAs,
	require: {
		app: "^^app"
	}
};

export default SigninComponent;


// WEBPACK FOOTER //
// ./sources/components/auth/signin/signin.component.js